import React from 'react'
import Img from 'gatsby-image'
import Link from 'gatsby-link'
import WAIcon from 'react-icons/lib/fa/whatsapp'
import CloseIcon from 'react-icons/lib/fa/close'
import HomeIcon from 'react-icons/lib/md/home'
import FBIcon from 'react-icons/lib/fa/facebook-square'
import TWIcon from 'react-icons/lib/fa/twitter'
import IGIcon from 'react-icons/lib/fa/instagram'
import EIcon from 'react-icons/lib/ti/mail'
import WSIson from 'react-icons/lib/fa/chain'

const Contacto = ({ data }) => (
  <div className="comprar-layout">        
    <h1>Contáctame</h1>
    <p>Gracias por confiar en mi trabajo.</p> 
     
     <ul className="collection with-header">
        <li className="collection-header"><h4>Redes Sociales</h4></li>
        <li className="collection-item"><a href="http://fiorellapattoni.com/contacto.html" target="_blank"><WSIson /> Página Web</a></li>
        <li className="collection-item"><a href="https://www.facebook.com/0.29kmDeEspacioNoCotidiano" target="_blank"><FBIcon /> Facebook</a></li>
        <li className="collection-item"><a href="https://www.instagram.com/fiorellapattoni/" target="_blank"><IGIcon /> Instagram</a></li>
        <li className="collection-item"><a href="https://twitter.com/FioPattoni" target="_blank"><TWIcon /> Twitter</a></li>
        <li className="collection-item"><a href="mailto:info@fiorellapattoni.com"><EIcon /> Email</a></li>
      </ul>

    <div class="nav-content">
      <ul className="tabs">        
        <li className="tab"><a href="whatsapp://send?abid=+50683075982"><WAIcon /> Whatsapp: 8307-5983</a></li>
        <li className="tab" ><Link to="/"><HomeIcon /> Inicio</Link></li>
        <li className="tab" ><Link to="acerca-de">Acerce de mi</Link></li>
      </ul>
    </div>
  
  </div>
)

export default Contacto





// WEBPACK FOOTER //
// ./src/pages/contacto.js